// Client-side persistence for recruiting "favorites" — hermes only, per-device.

import Vue from 'vue'

const KEY = 'recruiting-favorites:v1'

function readInitial() {
  try {
    const raw = localStorage.getItem(KEY)
    const arr = raw ? JSON.parse(raw) : []
    return Array.isArray(arr) ? arr : []
  } catch (_) {
    return []
  }
}

// Reactive source of truth. Components that call isFavorite() inside a computed
// or template track `state.ids` and update when it changes.
const state = Vue.observable({ ids: readInitial() })

function persist() {
  try {
    localStorage.setItem(KEY, JSON.stringify(state.ids))
  } catch (_) {
    // ignore quota / storage-disabled
  }
}

/** True when this opportunity id is marked favorite. */
export function isFavorite(oppId) {
  if (!oppId) return false
  return state.ids.indexOf(oppId) !== -1
}

/** Set (or clear) the favorite flag for an opportunity id. Returns the new state. */
export function setFavorite(oppId, favorite) {
  if (!oppId) return false
  const has = state.ids.indexOf(oppId) !== -1
  if (favorite && !has) {
    state.ids.push(oppId)
  } else if (!favorite && has) {
    state.ids = state.ids.filter((id) => id !== oppId)
  }
  persist()
  return !!favorite
}

/** Flip the favorite flag for an opportunity id. Returns the new state. */
export function toggleFavorite(oppId) {
  return setFavorite(oppId, !isFavorite(oppId))
}



// WEBPACK FOOTER //
// ./src/services/recruitingFavoritesStore.js